<script>
  import AXHR from "../components/js/axhr.js";
  import { fade } from "svelte/transition";
  import Location from "../components/Location.svelte";

  import { activeRoute } from "../pager/Router.svelte";
  import { onInterval } from "../components/js/intervall.js";
  import { session, routerboard } from "../components/js/store.js";
  let sessions;
  $: sessions;
  session.subscribe((value) => {
    sessions = value;
  });

  let routerboards;
  $: routerboards;
  routerboard.subscribe((value) => {
    routerboards = value;
  });

  export let backbtn = false;
  export let title = "";
  export let message = "Selamat Datang";
  export let align = "left";
  export let filter = false;
  export let filtercustom = false;
  let new_scroll_position = 0;
  let last_scroll_position;
  let navToggleclass = " lg:mt-0 md:mt-0 mt-12 top-0 left-0 z-20";
  window.addEventListener("scroll", function (e) {
    last_scroll_position = window.scrollY;
    // Scrolling down
    if (
      new_scroll_position < last_scroll_position &&
      last_scroll_position > 80
    ) {
      navToggleclass = " lg:mt-0 md:mt-0 -mt-2 top-0 left-0 z-20";
    } else if (new_scroll_position > last_scroll_position) {
      navToggleclass = " lg:mt-0 md:mt-0 mt-12 top-0 left-0 z-20";
    }

    new_scroll_position = last_scroll_position;
  });
  let navToggleMobileval = "hidden";
  let navToggleMobile = {
    show: "false",
  };

  function handleNavigationToggle() {
    navToggleMobile.show = !navToggleMobile.show;
    if (!navToggleMobile.show) {
      navToggleMobileval = "block";
      document.body.style.overflowY = "hidden";
    } else {
      navToggleMobileval = "hidden";
      document.body.style.overflowY = "auto";
    }
  }

  function toggleFilter() {
    if (document.getElementById("filterCont").style.display == "none") {
      document.getElementById("filterCont").style.display = "block";
    } else if (document.getElementById("filterCont").style.display == "block") {
      document.getElementById("filterCont").style.display = "none";
    } else {
      document.getElementById("filterCont").style.display = "block";
    }
  }

  let pingColor = "gray";
  let errorEvent = 0;
  async function checkServer(endpoint, token) {
    if (errorEvent < 1) {
      var config = {
        method: "get",
        url: endpoint,
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      AXHR(config)
        .then(function (response) {
          routerboard.update((n) => response.data);
          console.log(routerboards);
          pingColor = "green";
          errorEvent = 0;
        })
        .catch(function (error) {
          pingColor = "red";
          errorEvent = errorEvent + 1;
        });
    }
  }
  var url = $activeRoute.path.split("/");
  if (url[1] !== "server" && url[1] !== "points" && url[1] !== "akun") {
    if (sessions.routeractive) {
      checkServer(
        sessions.api + "/rb/" + sessions.routeractive.id + "/ping",
        sessions.token
      );
    }
    onInterval(() => {
      if (sessions.routeractive) {
        checkServer(
          sessions.api + "/rb/" + sessions.routeractive.id + "/ping",
          sessions.token
        );
      }
    }, 30000);
  }
  setTimeout(function () {
    var tidioScript = document.createElement("script");
    tidioScript.src = "//code.tidio.co/lljpybcmz3lftawbmohoa5rozjv1oaiq.js";
    document.body.appendChild(tidioScript);
    document.tidioIdentify = {
      distinct_id: sessions.user.id,
      email: sessions.user.email,
      name: sessions.user.firstName + " " + sessions.user.lastName,
    };
  }, 5 * 1000);
  function onTidioChatApiReady() {
    window.tidioChatApi.open();
  }
  function openChat() {
    if (window.tidioChatApi) {
      window.tidioChatApi.on("ready", onTidioChatApiReady);
    } else {
      document.addEventListener("tidioChat-ready", onTidioChatApiReady);
    }
  }
</script>

<header
  transition:fade
  class="fixed top-0 left-0 z-50 flex items-center justify-between w-full h-12 p-2 py-3 bg-white shadow-sm mobile-header md:hidden"
  style=""
>
  <nav class="flex items-center justify-between w-full h-full py-2">
    <button
      on:click={handleNavigationToggle}
      type="button"
      class="block p-2 text-center border border-gray-300 rounded-lg lg:hidden md:block color-gray-800 focus:outline-none"
      aria-label="toggle menu"
    >
      {#if sessions.notifycations}
        {#if sessions.notifycations.invoice > 0}
          <span
            class="absolute top-0 w-3 h-3 mt-2 ml-3 font-mono text-xs font-normal text-center text-red-700 bg-red-500 bg-opacity-75 rounded-full"
            >&nbsp;</span
          >
        {/if}
      {/if}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        class="w-4 h-4"
        ><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" /></svg
      ></button
    >
    <a
      class="block h-5 mx-auto -mt-3 text-2xl font-bold text-center text-black"
      href="./"
      ><img
        src="./assets/logo/logo.svg"
        alt="Mikhub"
        class="h-8"
        width="140"
        height="32"
      /></a
    >

    {#if sessions.notifycations === ""}
      <a
        class="flex px-2 py-1 text-xs text-center text-gray-800 border-2 border-gray-300 rounded-lg rounded-tr-none md:hidden"
        href="/login">MASUK</a
      >
    {:else}
      <a
        class="flex p-2 text-center border border-gray-300 rounded-lg md:hidden color-gray-800"
        href="/points"
        ><svg
          class="inline-block w-4 h-4 text-gray-800 stroke-current"
          xmlns="http://www.w3.org/2000/svg"
          version="1"
          viewBox="0 0 48 48"
          enable-background="new 0 0 48 48"
          ><g fill="#FFA000"
            ><path
              d="M38,13c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,12.1,41.3,13,38,13 z"
            /><path
              d="M38,10c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,9.1,41.3,10,38,10z"
            /><path
              d="M38,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,15.1,41.3,16,38,16 z"
            /><path
              d="M38,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,18.1,41.3,19,38,19 z"
            /><path
              d="M38,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,21.1,41.3,22,38,22 z"
            /><path
              d="M38,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,24.1,41.3,25,38,25 z"
            /><path
              d="M38,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,27.1,41.3,28,38,28 z"
            /><path
              d="M38,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,30.1,41.3,31,38,31 z"
            /><path
              d="M38,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,33.1,41.3,34,38,34 z"
            /><path
              d="M38,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,36.1,41.3,37,38,37 z"
            /><path
              d="M38,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C44,39.1,41.3,40,38,40 z"
            /></g
          ><g fill="#FFC107"
            ><ellipse cx="38" cy="8" rx="6" ry="2" /><path
              d="M38,12c-2.8,0-5.1-0.6-5.8-1.5C32.1,10.7,32,10.8,32,11c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,11.4,40.8,12,38,12z"
            /><path
              d="M38,15c-2.8,0-5.1-0.6-5.8-1.5C32.1,13.7,32,13.8,32,14c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,14.4,40.8,15,38,15z"
            /><path
              d="M38,18c-2.8,0-5.1-0.6-5.8-1.5C32.1,16.7,32,16.8,32,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,17.4,40.8,18,38,18z"
            /><path
              d="M38,21c-2.8,0-5.1-0.6-5.8-1.5C32.1,19.7,32,19.8,32,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,20.4,40.8,21,38,21z"
            /><path
              d="M38,24c-2.8,0-5.1-0.6-5.8-1.5C32.1,22.7,32,22.8,32,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,23.4,40.8,24,38,24z"
            /><path
              d="M38,27c-2.8,0-5.1-0.6-5.8-1.5C32.1,25.7,32,25.8,32,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,26.4,40.8,27,38,27z"
            /><path
              d="M38,30c-2.8,0-5.1-0.6-5.8-1.5C32.1,28.7,32,28.8,32,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,29.4,40.8,30,38,30z"
            /><path
              d="M38,33c-2.8,0-5.1-0.6-5.8-1.5C32.1,31.7,32,31.8,32,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,32.4,40.8,33,38,33z"
            /><path
              d="M38,36c-2.8,0-5.1-0.6-5.8-1.5C32.1,34.7,32,34.8,32,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,35.4,40.8,36,38,36z"
            /><path
              d="M38,39c-2.8,0-5.1-0.6-5.8-1.5C32.1,37.7,32,37.8,32,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C43.1,38.4,40.8,39,38,39z"
            /></g
          ><g fill="#FFA000"
            ><path
              d="M10,19c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,18.1,13.3,19,10,19 z"
            /><path
              d="M10,16c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,15.1,13.3,16,10,16 z"
            /><path
              d="M10,22c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,21.1,13.3,22,10,22 z"
            /><path
              d="M10,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,24.1,13.3,25,10,25 z"
            /><path
              d="M10,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,27.1,13.3,28,10,28 z"
            /><path
              d="M10,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,30.1,13.3,31,10,31 z"
            /><path
              d="M10,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,33.1,13.3,34,10,34 z"
            /><path
              d="M10,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,36.1,13.3,37,10,37 z"
            /><path
              d="M10,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C16,39.1,13.3,40,10,40 z"
            /></g
          ><g fill="#FFC107"
            ><ellipse cx="10" cy="14" rx="6" ry="2" /><path
              d="M10,18c-2.8,0-5.1-0.6-5.8-1.5C4.1,16.7,4,16.8,4,17c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,17.4,12.8,18,10,18z"
            /><path
              d="M10,21c-2.8,0-5.1-0.6-5.8-1.5C4.1,19.7,4,19.8,4,20c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,20.4,12.8,21,10,21z"
            /><path
              d="M10,24c-2.8,0-5.1-0.6-5.8-1.5C4.1,22.7,4,22.8,4,23c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,23.4,12.8,24,10,24z"
            /><path
              d="M10,27c-2.8,0-5.1-0.6-5.8-1.5C4.1,25.7,4,25.8,4,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,26.4,12.8,27,10,27z"
            /><path
              d="M10,30c-2.8,0-5.1-0.6-5.8-1.5C4.1,28.7,4,28.8,4,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,29.4,12.8,30,10,30z"
            /><path
              d="M10,33c-2.8,0-5.1-0.6-5.8-1.5C4.1,31.7,4,31.8,4,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,32.4,12.8,33,10,33z"
            /><path
              d="M10,36c-2.8,0-5.1-0.6-5.8-1.5C4.1,34.7,4,34.8,4,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,35.4,12.8,36,10,36z"
            /><path
              d="M10,39c-2.8,0-5.1-0.6-5.8-1.5C4.1,37.7,4,37.8,4,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C15.1,38.4,12.8,39,10,39z"
            /></g
          ><g fill="#FFA000"
            ><path
              d="M24,28c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,27.1,27.3,28,24,28 z"
            /><path
              d="M24,25c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,24.1,27.3,25,24,25 z"
            /><path
              d="M24,31c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,30.1,27.3,31,24,31 z"
            /><path
              d="M24,34c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,33.1,27.3,34,24,34 z"
            /><path
              d="M24,37c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,36.1,27.3,37,24,37 z"
            /><path
              d="M24,40c-3.3,0-6-0.9-6-2c0,0.4,0,1.6,0,2c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.4,0-1.6,0-2C30,39.1,27.3,40,24,40 z"
            /></g
          ><g fill="#FFC107"
            ><ellipse cx="24" cy="23" rx="6" ry="2" /><path
              d="M24,27c-2.8,0-5.1-0.6-5.8-1.5C18.1,25.7,18,25.8,18,26c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,26.4,26.8,27,24,27z"
            /><path
              d="M24,30c-2.8,0-5.1-0.6-5.8-1.5C18.1,28.7,18,28.8,18,29c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,29.4,26.8,30,24,30z"
            /><path
              d="M24,33c-2.8,0-5.1-0.6-5.8-1.5C18.1,31.7,18,31.8,18,32c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,32.4,26.8,33,24,33z"
            /><path
              d="M24,36c-2.8,0-5.1-0.6-5.8-1.5C18.1,34.7,18,34.8,18,35c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,35.4,26.8,36,24,36z"
            /><path
              d="M24,39c-2.8,0-5.1-0.6-5.8-1.5C18.1,37.7,18,37.8,18,38c0,1.1,2.7,2,6,2s6-0.9,6-2c0-0.2-0.1-0.3-0.2-0.5 C29.1,38.4,26.8,39,24,39z"
            /></g
          ></svg
        >
      </a>
    {/if}
  </nav>
</header>

<div
  transition:fade
  class="bg-white fixed w-full {navToggleclass} transition-all
  ease-in-out duration-100 shadow-sm"
>
  <div
    class="hidden w-full h-8 px-2 py-1 bg-gray-200 border-b border-gray-200 shadow-inner mobile-header lg:block md:block"
  >
    <div
      class="justify-between mx-auto text-sm font-light text-gray-700 max-w-screen-2xl md:flex md:items-center md:justify-between"
    >
      <div
        class="flex items-center justify-center w-full py-2 md:w-auto md:py-0"
      >
        <p class="text-gray-600">
          <span class="font-bold">Mikhubian Info :</span> Have a problem or need
          Payment Verification ? use
          <span
            class="italic text-black cursor-pointer"
            on:click|preventDefault={() => openChat()}>Mikhub Care</span
          >
        </p>
      </div>
      <div>
        <a href="https://mikhub.xyz/category/blog" class="mx-1"> Blog </a>
        <a href="https://mikhub.xyz/category/promo" class="mx-1"> Promo </a>
      </div>
    </div>
  </div>
  <div class="px-3 py-2 mx-auto lg:px-4 md:px-6 lg:py-2 md:py-2">
    <div
      class="justify-between mx-auto max-w-screen-2xl md:flex md:items-center md:justify-between"
    >
      <div class="flex items-center justify-between lg:mt-0 md:mt-0">
        <div
          class="flex justify-between w-full text-sm font-normal text-gray-700 lg:text-xl md:text-md"
        >
          {#if backbtn == "false"}
            <div class="block w-full lg:hidden md:hidden">
              <Location {pingColor} />
            </div>
            <a
              href="/"
              class="block hover:text-gray-800
      lg:text-left md:text-left text-{align} w-full lg:flex md:block hidden "
            >
              <h1 class="items-center text-3xl">
                <img
                  src="./assets/logo/logo.svg"
                  class="h-8"
                  alt="Mikhub"
                  width="140"
                  height="32"
                />
                {@html title}
              </h1>
            </a>
          {:else}
            <a
              href="/"
              class="h-8 md:w-32 lg:block md:block hidden hover:text-gray-800
              lg:text-left md:text-left text-{align} lg:mr-3"
            >
              <img
                src="./assets/logo/logo.svg"
                class="h-8"
                alt="Mikhub"
                width="140"
                height="32"
              />
            </a>
            <button
              {title}
              on:click={() => window.history.go(-1)}
              class="flex items-center px-3 mx-1 text-sm font-normal text-left border border-gray-200 rounded-lg hover:bg-gray-100 lg:text-md md:text-md lg:px-3 md:px-1 focus:outline-none"
            >
              <svg
                class="inline h-4 my-1 lg:my-1"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polygon
                  points="3.828 9 9.899 2.929 8.485 1.515 0 10 .707 10.707 8.485
                  18.485 9.899 17.071 3.828 11 20 11 20 9 3.828 9"
                />
              </svg>
              <span
                class="flex items-center w-full h-6 p-1 ml-2 overflow-hidden text-xs lg:hidden ellipsis-1 lg:w-32 md:w-32"
                >{title}</span
              >
            </button>
            {#if filter}
              {#if filtercustom}
                <button
                  class="flex items-center px-2 mx-2 text-xs border border-gray-300 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-gray-800"
                  on:click={toggleFilter}>{@html filtercustom}</button
                >
              {:else}
                <button
                  class="flex items-center px-2 mx-2 text-xs border border-gray-300 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-gray-800"
                  on:click={toggleFilter}
                >
                  <span>Filter</span>
                  <img
                    src="./assets/svg/search.svg"
                    alt="search"
                    class="inline-block w-3 h-3 m-1 lg:hidden"
                    width="17"
                    height="17"
                  />
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    class="hidden w-2 h-2 m-1 lg:w-3 lg:h-3 lg:inline-block"
                    ><path d="M12 12l8-8V0H0v4l8 8v8l4-4v-4z" /></svg
                  >
                </button>
              {/if}
            {/if}
          {/if}
        </div>
      </div>

      <!-- Mobile Menu open: "block", Menu closed: "hidden" -->
      <div
        class="{navToggleMobileval} md:flex md:items-center md:justify-between
        lg:h-auto md:h-auto h-screen flex-1 gap-2"
      >
        <div
          class="flex flex-col h-full pt-10 mx-2 font-normal md:flex-row md:items-center lg:mx-4 md:mx-0 lg:pt-0 md:pt-0"
        >
          <div
            class="relative hidden border-l-2 rounded-md lg:border-none lg:block md:hidden"
          >
            <a
              href="/server"
              on:click={() => (document.body.style.overflowY = "auto")}
              class="block px-2 py-1 mx-2 text-lg text-gray-700 rounded-md cursor-pointer lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
            >
              Server
            </a>
          </div>

          <a
            on:click={() => (document.body.style.overflowY = "auto")}
            href="/server"
            class="relative block px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800 lg:hidden md:block"
          >
            Server
          </a>
          <a
            on:click={() => (document.body.style.overflowY = "auto")}
            href="/points"
            class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
          >
            Points
          </a>

          {#if sessions.notifycations}
            {#if sessions.notifycations.invoice > 0}
              <a
                on:click={() => (document.body.style.overflowY = "auto")}
                href="/ngirim/accept"
                class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
              >
                Invoice

                {#if sessions.notifycations}
                  {#if sessions.notifycations.invoice > 0}
                    <span
                      class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-red-500 bg-opacity-75 rounded-full"
                    >
                      {sessions.notifycations.invoice}
                    </span>
                  {/if}
                {/if}
              </a>
            {:else}
              <a
                on:click={() => (document.body.style.overflowY = "auto")}
                href="/ngirim/all"
                class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
              >
                Invoice

                {#if sessions.notifycations}
                  {#if sessions.notifycations.invoice > 0}
                    <span
                      class="absolute top-0 inline px-2 -ml-2 font-mono text-xs font-normal text-center text-white bg-red-500 bg-opacity-75 rounded-full"
                    >
                      {sessions.notifycations.invoice}
                    </span>
                  {/if}
                {/if}
              </a>
            {/if}
          {:else}
            <a
              on:click={() => (document.body.style.overflowY = "auto")}
              href="/ngirim/accept"
              class="relative px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
            >
              Invoice
            </a>
          {/if}
          <a
            on:click={() => (document.body.style.overflowY = "auto")}
            href="/akun"
            class="relative block px-2 py-2 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800 lg:hidden md:hidden"
          >
            Akun
          </a>
        </div>

        <Location {pingColor} />
        <div class="items-center hidden mt-4 lg:flex md:flex md:mt-0">
          {#if message == "Selamat Datang"}
            <div
              class="flex flex-col h-full md:flex-row md:items-centerfont-normal"
            >
              <a
                href="/daftar"
                class="px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
              >
                Bergabung
              </a>
              <a
                href="/login"
                class="px-2 py-1 mx-2 mt-2 text-lg text-gray-700 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800"
              >
                Masuk
              </a>
            </div>
          {:else}
            <div class="items-center hidden mt-4 lg:flex md:flex md:mt-0">
              <a
                href="/akun"
                class="relative flex items-center px-2 mx-1 mt-2 text-lg text-gray-300 rounded-md md:mt-0 lg:text-sm md:text-sm hover:bg-gray-100 hover:text-gray-800 "
              >
                <div class="w-8 h-8 py-1 text-gray-300 focus:outline-none">
                  <svg
                    class="w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M5 5a5 5 0 0 1 10 0v2A5 5 0 0 1 5 7V5zM0 16.68A19.9
                      19.9 0 0 1 10 14c3.64 0 7.06.97 10 2.68V20H0v-3.32z"
                      fill="#555555"
                    />
                  </svg>
                </div>
                <h2
                  class="hidden w-16 h-5 text-sm leading-6 text-gray-700 truncate whitespace-pre-wrap font-base hover:text-gray-800 lg:inline-block"
                >
                  {@html message}
                </h2>
              </a>
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
{#if errorEvent > 0}
  <div
    transition:fade={{ duration: 400 }}
    class="fixed z-20 flex items-center justify-center w-screen h-screen bg-gray-900 bg-opacity-75"
  >
    <div
      class="max-w-md mx-2 text-blue-600 bg-white rounded-lg shadow-xl shake"
    >
      <p class="p-5 mb-5 text-center">
        <b class="text-xl">Oops... Could not ping server !</b><br />The selected
        server cannot be contacted, please check your server status details or
        internet connection to make sure everything is ok
      </p>

      <div class="flex justify-between">
        <a
          on:click|preventDefault={() => location.reload()}
          href="/server"
          class="block w-full px-5 py-2 text-center text-white bg-blue-500 rounded-bl-lg hover:bg-opacity-95"
          >Reload</a
        >
        <a
          href="/server"
          class="block w-full px-5 py-2 text-center text-white bg-gray-500 rounded-br-lg hover:bg-opacity-95"
          >Manage Servers »</a
        >
      </div>
    </div>
  </div>
{/if}
